import React from "react";

export interface InterventionItem {
  title: string;
  description: string;
  image?: string;
}

const FALLBACK_IMAGES: string[] = [
  "https://images.pexels.com/photos/265667/pexels-photo-265667.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.pexels.com/photos/3826328/pexels-photo-3826328.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.pexels.com/photos/814499/pexels-photo-814499.jpeg?auto=compress&cs=tinysrgb&w=1200",
  "https://images.pexels.com/photos/256514/pexels-photo-256514.jpeg?auto=compress&cs=tinysrgb&w=1200",
];

interface Props {
  interventions: InterventionItem[];
}

const InterventionQuadrants: React.FC<Props> = ({ interventions }) => {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "1.5rem",
        maxWidth: "100%",
      }}
    >
      {interventions.slice(0, 4).map((iv, i) => {
        const img = iv.image || FALLBACK_IMAGES[i % FALLBACK_IMAGES.length];
        return (
          <div
            key={iv.title}
            className="intervention-quadrant"
            style={{
              position: "relative",
              borderRadius: "var(--radius-lg)",
              overflow: "hidden",
              minHeight: "280px",
              display: "flex",
              alignItems: "flex-end",
              boxShadow: "var(--shadow-lg)",
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: 0,
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                transition: "transform 0.5s ease",
              }}
              aria-hidden
            />
            <div
              style={{
                position: "absolute",
                inset: 0,
                background:
                  "linear-gradient(180deg, rgba(10,22,40,0.15) 0%, rgba(10,22,40,0.55) 45%, rgba(10,22,40,0.88) 100%)",
              }}
              aria-hidden
            />
            <div
              style={{
                position: "relative",
                zIndex: 1,
                padding: "1.75rem",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "36px",
                  height: "36px",
                  borderRadius: "var(--radius-md)",
                  background: "var(--accent-500)",
                  color: "#fff",
                  fontWeight: 800,
                  fontSize: "0.95rem",
                  marginBottom: "0.75rem",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
                }}
              >
                {i + 1}
              </div>
              <h3
                style={{
                  fontSize: "1.2rem",
                  fontWeight: 700,
                  color: "#fff",
                  marginBottom: "0.5rem",
                  lineHeight: 1.3,
                  textShadow: "0 2px 8px rgba(0,0,0,0.5)",
                }}
              >
                {iv.title}
              </h3>
              <p
                style={{
                  fontSize: "0.9375rem",
                  lineHeight: 1.6,
                  color: "rgba(255,255,255,0.92)",
                  textShadow: "0 1px 4px rgba(0,0,0,0.5)",
                  margin: 0,
                }}
              >
                {iv.description}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default InterventionQuadrants;
